'use client'

import { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";

export default function DAMP_OCU_TRIANGULO({ exercise, isRunning, velocity }) {
  const [currentLine, setCurrentLine] = useState(0);
  const [size, setSize] = useState({ width: 0, height: 0 });
  const containerRef = useRef<HTMLDivElement>(null);
  const [rows, setRows] = useState(exercise.lineas) 
  const localVelocity = useRef(0)

  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        setSize({
          width: containerRef.current.offsetWidth,
          height: containerRef.current.offsetHeight,
        });
      }
    };

    updateSize();
    const resizeObserver = new ResizeObserver(updateSize);
    if (containerRef.current) {
      //resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  useEffect(() => {
    let interval = null
    if (isRunning && rows && localVelocity.current > 0) {
      interval = setInterval(() => {
        setCurrentLine((prev) => (prev + 1) % rows);
      }, localVelocity.current);
    }

    return () => {
      if (interval) clearInterval(interval);
    }
  }, [rows, isRunning, localVelocity.current]);

  const createPyramidLines = () => {
    const lines: string[] = [];
    const words = exercise.content.split(/\s+/);
    let wordIndex = 0;

    for (let i = 0; i < rows; i++) {
      const charsInLine = Math.floor(((size.width / rows) * (i + 1)) / 10);
      let line = "";

      while (line.length < charsInLine && wordIndex < words.length) {
        if (line.length + words[wordIndex].length <= charsInLine) {
          line += words[wordIndex] + " ";
          wordIndex++;
        } else {
          break;
        }
      }

      lines.push(line.trim());
    }
    let velocidad = ((60 / velocity) * 1000);
    velocidad = velocidad * (lines.join(" ").split(" ").length / exercise.lineas);
    localVelocity.current = velocidad
    return lines;
  };

  const lines = createPyramidLines();
  

  return (
    <Box
      ref={containerRef}
      sx={{
        width: "100%",
        height: "100%",
        minHeight: "100%",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        background: "#ffffff",
        paddingBottom: "20px"
      }}
    >
      <svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${size.width} ${size.height}`}
        preserveAspectRatio="xMidYMid meet"
      >
        {lines.map((line, index) => {
          const progress = (index + 1) / lines.length;
          const lineWidth = size.width * progress;
          const x = (size.width - lineWidth) / 2;
          const y = (size.height / (lines.length * 0.9)) * (index + 0.5);
          const fontSize = Math.min(
            size.height / (lines.length * 1.2),
            lineWidth / (line.length * 0.1)
          );

          return (
            <g key={index}>
              {index === currentLine && (
                <rect
                  x={x}
                  y={(size.height / (lines.length * 0.9)) * index}
                  width={lineWidth}
                  height={size.height / (lines.length * 0.9)}
                  fill="#BFDBFE"
                />
              )}
              <line x1={size.width / 2} y1="0" x2={size.width / 2} y2={size.height + 10} stroke="#666" strokeWidth="1" />
              <text
                x={size.width / 2}
                y={y}
                textAnchor="middle"
                dominantBaseline="middle"
                fill={index === currentLine ? "#000000" : "#999"}
                fontSize={fontSize}
                style={{ userSelect: "none", color: index === currentLine ? "#000000" : "#999", }}
              >
                {line}
              </text>
            </g>
          );
        })}
      </svg>
    </Box>
  );
}

